/**
 * @file Category.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2020
 */

import Service from './Service'
import Request from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

class Category extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
    // this.request = new Request({environment: 'local', tag: 'das'})
  }

  /**
   * Get category for layer and environment
   *
   * @async
   * @function get
   * @param {Number} environment - Environment Id
   * @param {string} layer - Layer Uid
   * @return {Promise<json>} The json with the layers
   */
  async get (environment, layer) {
    return new Promise((resolve, reject) => {
      if (typeof environment === 'undefined') reject(new Error('Esperado o identificador do environment'))
      if (typeof layer === 'undefined') reject(new Error('Esperado o identificador do layer'))
      const endPoint = `/api/0.1-a/Category/GetCategory/${environment}/${layer}/thematic`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get category relationship
   * @async
   * @function getParents
   * @param {string} category
   * @return {Promise<json>} The json with the result
   */
  async getParents (category) {
    return new Promise((resolve, reject) => {
      if (typeof category === 'undefined') reject(new Error('Esperado o identificador da categoria'))
      const endPoint = `/api/0.1-a/expression/gethierarchybychild/${category}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  async getOptionsMultiCategory (data, value) {
    return new Promise((resolve, reject) => {
      if (value === '') { value = '*' }
      const endPoint = '/api/0.1-a/Category/getMultiCategoryData/' + value.toUpperCase()
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }

  /**
   * Get seletor2 values for a treeview expression
   *
   * @async
   * @function getTreeviewSeletor2
   * @param {string} seletor
   * @param {Number} tableId - Table id
   * @return {Promise<json>} The json with the result
   */
  async getTreeviewSeletor2 (seletor, tableId) {
    return new Promise((resolve, reject) => {
      // const endPoint = '/api/0.1-a/ProxyPostgRest/api/rpc/treeview_get_seletormetadata'
      const endPoint = '/api/0.1-a/expressionmetadata/treeviewselector2'
      const data = {
        'seletor': seletor,
        'familyid': tableId
      }
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response.data))
        .catch(() => reject)
    })
  }
}

export {Category}
